"use strict";
/*
 * Created on 11 21 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author VRu
 * @author Jan Gregor (moved from data pump)
 */


var SimilarProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimilarProductConverter, _DataObjectConverter_);

  function SimilarProductConverter() {
    _classCallCheck(this, SimilarProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimilarProductConverter).apply(this, arguments));
  }

  return SimilarProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimilarProductConverter = SimilarProductConverter;